/// <reference path="DOMAttached.js" />

class Invitation extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.nextLink = this.el.querySelector('.nextStep');
		this.addLink = this.el.querySelector('.addName');
		this.namesForm = this.el.querySelector('.namesForm');
		this.noNamesError = this.el.querySelector('.error');
		this.nameslist = this.el.querySelector('.allNamesToInvite');
		this.invitationForm = this.el.querySelector('.invitationForm');
		this.invitationFormAnyError = this.invitationForm.querySelector('.error');
		this.heading = this.invitationForm.querySelector('h3');
		this.currentName = undefined;
		this.inviteLink = this.el.querySelector('.inviteSinglePerson');
		this.stateMessageForm = this.el.querySelector('.invitationStateMessageForm');
		this.nextInvitationName = this.stateMessageForm.querySelector('.nextNameToInvite');
		this.nextInvitationLink = this.stateMessageForm.querySelector('.nextInvitation');
		this.moreInvitationsLink = this.stateMessageForm.querySelector('.moreInvitations');
		this.safeObserve(this.nextLink, 'click', this.onNextClick.bind(this));
		this.safeObserve(this.addLink, 'click', this.onAddClick.bind(this));
		this.safeObserve(this.inviteLink, 'click', this.onInviteClick.bind(this));
		this.safeObserve(this.nextInvitationLink, 'click', this.onNextInvitationClick.bind(this));
		this.namesArray = new Array();
	}

	onNextClick(ev) {
		this.fillNamesArray();
		this.retrieveNextCurrentName();
		if (this.currentName != undefined) {
			this.putNameInHeading();
			this.goToSecondStep();
		} else {
			this.displayNoNamesError();
		}
	}

	onAddClick(ev) {
		this.addNameRow();
	}

	onInviteClick(ev) {
		this.sendInvitation();
	}

	onNextInvitationClick(ev) {
		this.tryToAdaptMessageForNextName();
		this.retrieveNextCurrentName();
		this.putNameInHeading();
		this.cleanUpInputMethod();
		this.goToSecondStep();
	}

	displayNoNamesError() {
		this.noNamesError.classList.remove('collapsed');
	}

	sendInvitation() {
		var selectedMethod = this.invitationForm.querySelector('.selected');

		var name = this.currentName;
		var message = selectedMethod.querySelector('textarea').value;
		var contact = selectedMethod.querySelector('.invitationMethodInput').querySelector('input[type="text"]').value;
		var method = selectedMethod.querySelector('.invitationMethodValue').value;

		axios(this.options.inviteURL, {
			method: 'post',
			headers: {
				'content-type': 'application/x-www-form-urlencoded'
			},
			data: {
				name: name,
				message: message,
				contact: contact,
				method: method
			}
		}).then((response) => {
			this.requestSuccess(response);
		});
	}

	addNameRow() {
		var newNameField = this.nameslist.querySelector('.singleNameToInvite').cloneNode(true);
		newNameField.querySelector('.textbox').querySelector('input[type="text"]').value = '';
		this.nameslist.appendChild(newNameField);
	}

	goToSecondStep() {
		this.namesForm.classList.add('collapsed');
		this.stateMessageForm.classList.add('collapsed');
		this.invitationForm.classList.remove('collapsed');
	}

	goToFinalStep() {
		this.invitationForm.classList.add('collapsed');
		this.stateMessageForm.classList.remove('collapsed');
	}

	fillNamesArray() {
		this.nameslist.querySelectorAll('.singleNameToInvite').forEach(function(el) {
			var name = el.querySelector('.textbox').querySelector('input[type="text"]').value.strip();
			if (name.length > 0)
				this.namesArray.push(name);
		}.bind(this));
		this.namesArray.reverse();
	}

	putNameInHeading() {
		this.heading.innerHTML = this.currentName;
	}

	putNextNameInNextInvitationLinkOrShowMoreInvitationsLink() {
		var nextName = this.namesArray[this.namesArray.length - 1];
		if (nextName != undefined) {
			this.nextInvitationName.innerHTML = nextName;
		} else {
			this.nextInvitationLink.classList.add('collapsed');
			this.moreInvitationsLink.classList.remove('collapsed');
		}
	}

	retrieveNextCurrentName() {
		this.currentName = this.namesArray.pop();
	}

	cleanUpInputMethod() {
		this.invitationForm.querySelectorAll('.invitationMethodInput').forEach(function(item) {
			item.querySelector('input[type="text"]').value = '';
		});
	}

	tryToAdaptMessageForNextName() {
		var message = this.invitationForm.querySelector('.selected').querySelector('textarea').value;
		message = message.replace(new RegExp('\\b' + this.currentName + '\\b', "gi"), this.namesArray[this.namesArray.length - 1]);
		this.invitationForm.querySelector('.selected').querySelector('textarea').value = message;
	}

	putSuccessMessageInPlace(message) {
		this.stateMessageForm.querySelector('.successMessage').innerHTML = message;
	}

	showInvitationFormError(errorMsg) {
		this.invitationFormAnyError.querySelector('p').innerHTML = errorMsg;
		this.invitationFormAnyError.classList.remove('collapsed');
	}

	requestSuccess(req) {
		var json;
		try {
			json = req.data;
		} catch (e) {
			this.requestFailure(req);
			return;
		}
		if (json.message) {
			if (json.success) {
				this.putNextNameInNextInvitationLinkOrShowMoreInvitationsLink();
				this.putSuccessMessageInPlace(json.message);
				this.goToFinalStep();
			} else {
				this.showInvitationFormError(json.message);
			}
		} else {
			this.requestFailure(req);
			return;
		}
	}

	requestFailure(req) {
		this.showInvitationFormError(this.options.genericError);
	}
}
